// extracted by mini-css-extract-plugin
export default {"container":"error_container__rkIVJ","link":"error_link__Tg8Ik"};